import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 16;
	width: 100%;
	height: 100%;
	background-color: #111314;
`;

const StyledHeadContainer = styled.div`
	display: grid;
	grid-template-columns: 20% 60% 20%;
	padding: 20px;
	align-items: center;
`;

const StyledHeadBackSlot = styled.div`
	justify-self: start;
`;

const StyledHeadCrossSlot = styled.div`
	justify-self: end;
`;

const StyledItemsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
	width: 100%;
`;

const StyledPreviewCard = styled.div<{ $active?: boolean }>`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 210px;
	padding: 10px;
	border-radius: 20px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	transition:
		background-color 0.3s ease,
		border-color 0.3s ease;
	cursor: pointer;

	${Text} {
		width: 100%;
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;
		text-align: center;
		color: #ffffff;
		margin-top: 17px;
		padding-bottom: 5px;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;
		border-color: #ffffff;

		${Text} {
			color: #000000;
		}
	}
`;

const StyledPreviewImageWrap = styled.div`
	width: 100%;
	flex: 1;
	min-height: 0;
	border-radius: 12px;
	overflow: hidden;
	background-color: rgba(0, 0, 0, 0.25);

	img {
		display: block;
		width: 100%;
		height: 150px;
		user-select: none;
		pointer-events: none;
		object-fit: cover;
	}
`;

const StyledClothesHeadline = styled(Text)`
	text-align: center;
	color: #ffffff;
	font-size: 14px;
	transition: color 0.3s ease;

	span {
		opacity: 0.25;
	}
`;

const StyledClothesCard = styled.div<{ $active?: boolean }>`
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	min-height: 210px;
	padding: 17px 20px 20px;
	border-radius: 20px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;
	cursor: pointer;

	&:hover {
		background-color: #ffffff;

		${StyledClothesHeadline} {
			color: #000000;
		}
	}
`;

const StyledClothesImageSlot = styled.div`
	display: flex;
	flex: 1;
	align-items: center;
	justify-content: center;
	margin-top: 17px;
`;

const StyledCollectionImageContainer = styled.div`
	display: flex;
	justify-content: center;
	height: 81px;
	margin: 32px auto 0;
`;

const StyledVehicleContainer = styled.div<{ $active?: boolean }>`
	height: 210px;
	padding-top: 17px;
	border-radius: 20px;
	overflow: hidden;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;
	cursor: pointer;

	& > ${Text} {
		font-size: 14px;
		color: #ffffff;
		text-align: center;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		& > ${Text} {
			color: #000000;
		}
	}
`;

const StyledPlateContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 15px;
`;

const StyledContinueWrap = styled.div`
	position: absolute;
	left: 50%;
	bottom: 20px;
	transform: translateX(-50%);
`;

export {
	StyledClothesCard,
	StyledClothesHeadline,
	StyledClothesImageSlot,
	StyledCollectionImageContainer,
	StyledContainer,
	StyledContinueWrap,
	StyledHeadBackSlot,
	StyledHeadContainer,
	StyledHeadCrossSlot,
	StyledItemsGrid,
	StyledPlateContainer,
	StyledPreviewCard,
	StyledPreviewImageWrap,
	StyledVehicleContainer,
};
